import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { HealthHistoryFilterState } from '@libs/store';

@Component({
  selector: 'lib-health-history-filter',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './health-history-filter.component.html',
  styleUrl: './health-history-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryFilterComponent {
  public readonly filterState = input.required<HealthHistoryFilterState>();
  public readonly visibleCount = input.required<number>();
  public readonly totalCount = input.required<number>();
  public readonly filterChanged = output<HealthHistoryFilterState>();

  protected readonly isCriticalEnabled = computed(
    () =>
      this.filterState() === HealthHistoryFilterState.Critical ||
      this.filterState() === HealthHistoryFilterState.CriticalActive ||
      this.filterState() === HealthHistoryFilterState.CriticalInactive,
  );

  protected readonly isActiveEnabled = computed(
    () => this.filterState() === HealthHistoryFilterState.Active || this.filterState() === HealthHistoryFilterState.CriticalActive,
  );

  protected readonly isInactiveEnabled = computed(
    () => this.filterState() === HealthHistoryFilterState.Inactive || this.filterState() === HealthHistoryFilterState.CriticalInactive,
  );

  protected toggleCritical(): void {
    this.emitNextState(!this.isCriticalEnabled(), this.isActiveEnabled(), this.isInactiveEnabled());
  }

  protected toggleActive(): void {
    const nextActive = !this.isActiveEnabled();
    const nextInactive = nextActive ? false : this.isInactiveEnabled();
    this.emitNextState(this.isCriticalEnabled(), nextActive, nextInactive);
  }

  protected toggleInactive(): void {
    const nextInactive = !this.isInactiveEnabled();
    const nextActive = nextInactive ? false : this.isActiveEnabled();
    this.emitNextState(this.isCriticalEnabled(), nextActive, nextInactive);
  }

  private emitNextState(critical: boolean, active: boolean, inactive: boolean): void {
    // Active and Inactive are guaranteed mutually exclusive by the toggle handlers.
    if (critical && active) {
      this.filterChanged.emit(HealthHistoryFilterState.CriticalActive);
    } else if (critical && inactive) {
      this.filterChanged.emit(HealthHistoryFilterState.CriticalInactive);
    } else if (critical) {
      this.filterChanged.emit(HealthHistoryFilterState.Critical);
    } else if (active) {
      this.filterChanged.emit(HealthHistoryFilterState.Active);
    } else if (inactive) {
      this.filterChanged.emit(HealthHistoryFilterState.Inactive);
    } else {
      this.filterChanged.emit(HealthHistoryFilterState.None);
    }
  }
}
